/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activitySearchIdsInternal} from '../api'

export const useMutationActivitySearchIdsInternal = createReactQueryMutationHook('activitySearchIdsInternal', activitySearchIdsInternal)
